export const GET_FAQS = "GET_FAQS";
export const FILTER_FAQS = "FILTER_FAQS";
export const ADD_FAQ = "ADD_FAQ";
export const EDIT_FAQ = "EDIT_FAQ";
export const GET_FAQ = "GET_FAQ";
export const RESET_FAQ = "RESET_FAQ";
export const FAQS_ERROR = "FAQS_ERROR";
